import React from "react";
import { useTranslation } from "react-i18next";
import PopupTrigger from "../../../../common/PopupTrigger";
import Popup from "../../../../common/Popup";

const ClosePopup = ( props ) => {

  const { t } = useTranslation();

  return (
    <PopupTrigger>
      { props.children }
      <Popup onConfirm={ props.onClose }>
        <p className="lc-alert_txt m-fw-normal" dangerouslySetInnerHTML={ { __html : t( 'LC_02_06.msg008' ) } } />
      </Popup>
    </PopupTrigger>
  );

};

export default ClosePopup;
